import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-creates',
  imports: [NgOptimizedImage],
  templateUrl: './creates.html',
  styleUrl: './creates.css',
})
export class Creates {

}
